var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sort-button",class:{active: _vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_c('FaIcon',{attrs:{"icon":_vm.icon,"fixed-width":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }